import { Component, Input } from '@angular/core';

@Component({
  selector: 'upsell-disclaimer',
  templateUrl: './upsell-disclaimer.component.html',
  styleUrls: ['./upsell-disclaimer.component.scss']
})
export class UpsellDisclaimerComponent {
  @Input() disclaimerText: string = 'We work hard to formulate the most advanced, all-natural products on the market. Our 90-Day Customer Satisfaction Guarantee is designed to give you ample opportunity to experience optimal results from your product, completely risk-free.';
}
